import { useEffect, useState } from 'react';

// @Utility
import { getStorage, setStorage, removeStorage } from "@utility/app/storage";
import timeZone from "@utility/app/timeZone";
import currencyFormat from "@utility/numbers/currencyFormat";

// Redux & Action
import { useDispatch } from 'react-redux';
import { setWithdrawRankData } from '@core/redux/actions/withdraw/index';

// Component
import Slider from 'react-slick';
import { Grid, Paper } from '@mui/material';

// Icon
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

// CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function RankWithdraw({ pageName, withdrawRank }) {
    const dispatch = useDispatch();
    const [withdrawRankLength, setWithdrawRankLength] = useState(0);
    const [dataBackup, setDataBackup] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [dataListLength, setDataListLength] = useState(0);

    // console.log(dataListLength, withdrawRankLength)

    const settings = {
        infinite: withdrawRank !== null ? withdrawRank.length < 5 ? false : true : true,
        dots: false,
        slidesToShow: withdrawRank !== null ? withdrawRank.length < 5 ? withdrawRank.length : 5 : 5,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: false,
        pauseOnHover: false,
        beforeChange: (oldIndex) => {
            if (dataList[oldIndex]?.key !== undefined) {
                setStorage("withdrawRankKey", dataList[oldIndex].key);
                if ((withdrawRankLength - 1) === dataList[oldIndex].key) {
                    removeStorage("withdrawRankKey");
                    dispatch(setWithdrawRankData());
                }
                else {
                    // console.log(dataListLength - 1, oldIndex)
                    if ((dataListLength - 1) === oldIndex) {
                        resetDataRank();
                    }
                }
            }
            else {
                removeStorage("withdrawRankKey");
                dispatch(setWithdrawRankData());
            }
        }
    }

    const resetDataRank = () => {
        let dataArrBackup = withdrawRank;
        let dataArrSetIndex = [];
        let withdrawRankKey = Number(getStorage("withdrawRankKey"));
        let getDataArr = [];

        // console.log("withdrawRankKey : ", withdrawRankKey)

        dataArrBackup.forEach((item, index) => {
            dataArrSetIndex = [...dataArrSetIndex, { ...item, key: index }];
        });

        setDataBackup(dataArrSetIndex);

        if (withdrawRankKey === undefined || withdrawRankKey === null || withdrawRankKey === "" || withdrawRankKey === false || withdrawRankKey === NaN) {
            removeStorage("withdrawRankKey");
            let dataArrNull = [];

            for (let index = 0; index < 10; index++) {
                dataArrNull = [...dataArrNull, { ...dataArrSetIndex[index] }];
            }

            getDataArr = dataArrNull;
        }
        else {
            let findKey = dataArrSetIndex.find((item) => withdrawRankKey === item.key);
            if (findKey === undefined) {

                removeStorage("withdrawRankKey");
                let dataArrDefault = [];

                for (let index = 0; index < 10; index++) {
                    dataArrDefault = [...dataArrDefault, { ...dataArrSetIndex[index] }];
                }

                getDataArr = dataArrDefault;
            }
            else {
                if ((withdrawRankLength - 1) === withdrawRankKey) {
                    removeStorage("withdrawRankKey");
                    dispatch(setWithdrawRankData());
                }
                else {
                    let dataNewWithKey = dataArrSetIndex.filter((item) => item.key > withdrawRankKey);
                    let dataArrLoop = [];

                    // console.log(dataNewWithKey)

                    for (let index = 0; index < 10; index++) {
                        if (dataNewWithKey[index]?.key !== undefined) {
                            dataArrLoop.push(dataNewWithKey[index]);
                        }
                    }

                    getDataArr = dataArrLoop;
                }
            }

            setDataListLength(getDataArr.length);
            setDataList(getDataArr);
        }
    };

    // useEffect(() => {
    //     dispatch(setWithdrawRankData());
    // }, []);

    useEffect(() => {
        if (withdrawRank !== null && withdrawRank !== [] && withdrawRank !== undefined) {
            setWithdrawRankLength(withdrawRank.length);
            resetDataRank();
        }
    }, [withdrawRank]);

    return withdrawRank !== null && (
        <>
            <Paper variant='outlined' className="rankBlock positionRelative">
                <div className="positionAbsolute widthFull topLeft rankHeadTop">
                    <img src={window.location.origin + "/images/rank/H.webp"} className="rankHead" />
                </div>
                <div className="rankUserTitle">
                    {pageName}
                </div>

                <hr className="middleLine" />

                <div className="boxMarginTop">
                    <div className="withdrawRankCard">
                        <Grid container justifyContent="center" alignItems="center">
                            <Grid item xs={12} md={12}>
                                <Slider {...settings}>
                                    {
                                        dataList.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <div className="rankWithdrawList">
                                                        <div className="rankWithdrawPadding">
                                                            <Grid container justifyContent="center">
                                                                <Grid item className="rankWithdrawWidth">
                                                                    <Grid container alignItems="center">
                                                                        <Grid item xs={3} className="center">
                                                                            <AccountBalanceIcon className="footerIconSize"></AccountBalanceIcon>
                                                                        </Grid>
                                                                        <Grid item xs={9}>
                                                                            <div>
                                                                                <span>
                                                                                    ยูส: <span className="textGold">{item.username}</span>
                                                                                </span>
                                                                                <span className="rankWithdrawTextPadding">
                                                                                    วันที่: <span className="textGold">{timeZone(item.time_create, "datetime")}</span>
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <span>
                                                                                    ยอดถอน: <span className="textGold">{currencyFormat(item.amount, 2)}</span> บาท
                                                                                </span>
                                                                            </div>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </Grid>
                        </Grid>
                    </div>
                </div>

                <div className="positionAbsolute widthFull bottomLeft rankFooterBottom">
                    <img src={window.location.origin + "/images/rank/D.webp"} className="rankFooter" />
                </div>
            </Paper>
        </>
    )
}
